import React from 'react';

import { Comment as CommentType, CommentableType } from '@utils/backend-api/comments';

import Comment from './Comment';

export default function CommentsFeed({
  comments,
  commentableType,
  level,
  setParentReplyingTo,
}: {
  comments: CommentType[];
  commentableType: CommentableType;
  level?: number;
  setParentReplyingTo?: (replyingTo: string) => void;
}) {
  return (
    <div>
      {comments.map((comment) => (
        <Comment
          key={comment.id}
          comment={comment}
          level={level}
          setParentReplyingTo={setParentReplyingTo}
          commentableType={commentableType}
        />
      ))}
    </div>
  );
}
